import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { HttpClientModule } from '@angular/common/http';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';

import '@angular/common/locales/global/ar';
import '@angular/common/locales/global/de';
import '@angular/common/locales/global/fr';
import '@angular/common/locales/global/es';
import { HomeRedesignComponent } from './components/pages/home-redesign/home-redesign.component';
import { HeaderRedesignComponent } from './components/layout/header-redesign/header-redesign.component';
import { FooterRedesignComponent } from './components/layout/footer-redesign/footer-redesign.component';
import { HeroRedesignComponent } from './components/hero-redesign/hero-redesign.component';
import { LogoShowcaseRedesignComponent } from './components/logo-showcase-redesign/logo-showcase-redesign.component';
import { FeatureSectionRedesignComponent } from './components/feature-section-redesign/feature-section-redesign.component';
import { FeaturesGridRedesignComponent } from './components/features-grid-redesign/features-grid-redesign.component';
import { FeatureSectionAltRedesignComponent } from './components/feature-section-alt-redesign/feature-section-alt-redesign.component';
import { BenefitsGridRedesignComponent } from './components/benefits-grid-redesign/benefits-grid-redesign.component';
import { ComparisonSectionRedesignComponent } from './components/comparison-section-redesign/comparison-section-redesign.component';
import { DevicesSectionRedesignComponent } from './components/devices-section-redesign/devices-section-redesign.component';
import { CtaSectionRedesignComponent } from './components/cta-section-redesign/cta-section-redesign.component';
import { TestimonialsRedesignComponent } from './components/testimonials-redesign/testimonials-redesign.component';
import { CtaBannerRedesignComponent } from './components/cta-banner-redesign/cta-banner-redesign.component';
import { SolutionsRedesignComponent } from './components/pages/solutions-redesign/solutions-redesign.component';
import { PageHeroRedesignComponent } from './components/page-hero-redesign/page-hero-redesign.component';
import { SolutionsOverviewRedesignComponent } from './components/solutions-overview-redesign/solutions-overview-redesign.component';
import { CtaRedesignComponent } from './components/cta-redesign/cta-redesign.component';
import { AboutRedesignComponent } from './components/pages/about-redesign/about-redesign.component';
import { AboutIntroRedesignComponent } from './components/about-intro-redesign/about-intro-redesign.component';
import { MissionVisionRedesignComponent } from './components/mission-vision-redesign/mission-vision-redesign.component';
import { ContentImageRedesignComponent } from './components/content-image-redesign/content-image-redesign.component';
import { TextImageRedesignComponent } from './components/text-image-redesign/text-image-redesign.component';
import { ContactHighlightRedesignComponent } from './components/contact-highlight-redesign/contact-highlight-redesign.component';
import { WhyAltheaRedesignComponent } from './components/why-althea-redesign/why-althea-redesign.component';
import { PlatformRedesignComponent } from './components/pages/platform-redesign/platform-redesign.component';
import { PlatformFeatureRedesignComponent } from './components/platform-feature-redesign/platform-feature-redesign.component';
import { NewsRedesignComponent } from './components/pages/news-redesign/news-redesign.component';
import { NewsListRedesignComponent } from './components/news-list-redesign/news-list-redesign.component';
import { NewsSingleRedesignComponent } from './components/pages/news-single-redesign/news-single-redesign.component';
import { ContactRedesignComponent } from './components/pages/contact-redesign/contact-redesign.component';
import { ContactSectionRedesignComponent } from './components/contact-section-redesign/contact-section-redesign.component';
import { Fens2026Component } from './components/pages/news-single-redesign/fens2026.component';

@NgModule({
  declarations: [
    AppComponent,
    HomeRedesignComponent,
    HeaderRedesignComponent,
    FooterRedesignComponent,
    HeroRedesignComponent,
    LogoShowcaseRedesignComponent,
    FeatureSectionRedesignComponent,
    FeaturesGridRedesignComponent,
    FeatureSectionAltRedesignComponent,
    BenefitsGridRedesignComponent,
    ComparisonSectionRedesignComponent,
    DevicesSectionRedesignComponent,
    CtaSectionRedesignComponent,
    TestimonialsRedesignComponent,
    CtaBannerRedesignComponent,
    SolutionsRedesignComponent,
    PageHeroRedesignComponent,
    SolutionsOverviewRedesignComponent,
    CtaRedesignComponent,
    AboutRedesignComponent,
    AboutIntroRedesignComponent,
    MissionVisionRedesignComponent,
    ContentImageRedesignComponent,
    TextImageRedesignComponent,
    ContactHighlightRedesignComponent,
    WhyAltheaRedesignComponent,
    PlatformRedesignComponent,
    PlatformFeatureRedesignComponent,
    NewsRedesignComponent,
    Fens2026Component,
    NewsListRedesignComponent,
    NewsSingleRedesignComponent,
    ContactRedesignComponent,
    ContactSectionRedesignComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    HttpClientModule,
    FormsModule,
    ReactiveFormsModule,
    NgbModule
  ],
  providers: [],
  bootstrap: [AppComponent]
})
export class AppModule { }
